import { render, staticRenderFns } from "./genericData.vue?vue&type=template&id=3124a0b0"
import script from "./genericData.vue?vue&type=script&lang=js"
export * from "./genericData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports